import type { PropsWithChildren } from 'react'
import React from 'react'
import Row from '../row'

export default (props: PropsWithChildren<Record<string, unknown>>): JSX.Element => <Row {...props} alignX="end" />
